'use client'

import Image from '@/components/Image'
import { useTranslation } from '@/contexts/I18nContext'
import { notificationText } from './styles'

export function NotificationEmptyState() {
  const { t } = useTranslation('message')

  return (
    <div className="flex flex-col items-center px-[calc(24*var(--vw))] pt-[calc(182*var(--vw))]">
      <div className="relative size-[calc(80*var(--vw))] shrink-0 overflow-hidden">
        <Image
          src="/common/notificationEmptyMailbox.png"
          alt=""
          width={160}
          height={160}
          className="size-full object-contain"
        />
      </div>
      <p
        className={`mt-[calc(12*var(--vw))] text-center text-[calc(14*var(--vw))] font-normal leading-[calc(20*var(--vw))] ${notificationText.disabled}`}
      >
        {t('Message.Notification.Empty')}
      </p>
    </div>
  )
}
